var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "archive-filter-bar" } }, [
    _c("div", { staticClass: "filter-section" }, [
      _c("div", { staticClass: "filter-toolbar" }, [
        _c("div", { staticClass: "filter-button" }, [
          _c(
            "button",
            {
              staticClass: "custom-filter-button",
              class: { "active-filter": _vm.activeFilterCount > 0 },
              on: { click: _vm.toggleFilterModal },
            },
            [
              _c("span", { staticClass: "material-icons" }, [_vm._v("tune")]),
              _vm._v(" "),
              _c("span", { staticClass: "button-text" }, [_vm._v("Filtreler")]),
              _vm._v(" "),
              _vm.activeFilterCount > 0
                ? _c("span", { staticClass: "filter-count" }, [
                    _vm._v(_vm._s(_vm.activeFilterCount)),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.isFilterModalOpen
            ? _c("div", { ref: "filterPanel", staticClass: "filter-panel" }, [
                _c("div", { staticClass: "filter-panel-arrow" }),
                _vm._v(" "),
                _c("div", { staticClass: "filter-panel-content" }, [
                  _c("div", { staticClass: "filter-header" }, [
                    _c("h3", [_vm._v("Filtreleme Seçenekleri")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "filter-header-actions" },
                      [
                        _c(
                          "a-button",
                          {
                            staticClass: "reset-button",
                            attrs: { type: "link" },
                            on: { click: _vm.resetFilters },
                          },
                          [
                            _vm._v(
                              "\n                                    Sıfırla\n                                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            staticClass: "apply-button",
                            attrs: { type: "primary" },
                            on: { click: _vm.applyFilters },
                          },
                          [
                            _vm._v(
                              "\n                                    Uygula\n                                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "close-button",
                            on: { click: _vm.closeFilterModal },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("close"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "filter-tab-layout" }, [
                    _c(
                      "div",
                      { staticClass: "filter-tabs" },
                      _vm._l(_vm.filterTabs, function (tab) {
                        return _c(
                          "div",
                          {
                            key: tab.key,
                            class: [
                              "filter-tab",
                              { active: _vm.activeFilterTab === tab.key },
                            ],
                            on: {
                              click: function ($event) {
                                _vm.activeFilterTab = tab.key
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(tab.title) +
                                "\n                                    "
                            ),
                            _vm.hasActiveFilterInTab(tab.key)
                              ? _c("span", {
                                  staticClass: "tab-filter-indicator",
                                })
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-tab-content" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeFilterTab === "quickFilters",
                              expression: "activeFilterTab === 'quickFilters'",
                            },
                          ],
                          staticClass: "filter-tab-pane",
                        },
                        [
                          _c("div", { staticClass: "filter-options" }, [
                            _c("h4", [_vm._v("Tarih Aralığı")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "custom-date-inputs" }, [
                              _c(
                                "div",
                                { staticClass: "date-input-group" },
                                [
                                  _c("label", [_vm._v("Başlangıç Tarihi")]),
                                  _vm._v(" "),
                                  _c("datetime", {
                                    attrs: {
                                      "max-datetime": _vm.maxDate,
                                      "min-datetime": _vm.lastFiveYear,
                                      type: "datetime",
                                      "input-class": "form-control",
                                    },
                                    model: {
                                      value: _vm.localStartDate,
                                      callback: function ($$v) {
                                        _vm.localStartDate = $$v
                                      },
                                      expression: "localStartDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "date-input-group" },
                                [
                                  _c("label", [_vm._v("Bitiş Tarihi")]),
                                  _vm._v(" "),
                                  _c("datetime", {
                                    attrs: {
                                      "max-datetime": _vm.maxDate,
                                      "min-datetime": _vm.localStartDate,
                                      type: "datetime",
                                      "input-class": "form-control",
                                    },
                                    model: {
                                      value: _vm.localEndDate,
                                      callback: function ($$v) {
                                        _vm.localEndDate = $$v
                                      },
                                      expression: "localEndDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "filter-options" }, [
                            _c("h4", [_vm._v("Hızlı Filtreler")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "quick-filters-grid" }, [
                              _c(
                                "div",
                                {
                                  class: [
                                    "quick-filter-card",
                                    { selected: _vm.localFilterDescription },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleFilter("description")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "filter-icon-wrapper" },
                                    [_c("md-icon", [_vm._v("comment")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "filter-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("message.showFeedbackHistory")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class: [
                                    "quick-filter-card",
                                    { selected: _vm.localFilterVideoCall },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleFilter("videoCall")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "filter-icon-wrapper" },
                                    [_c("md-icon", [_vm._v("videocam")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "filter-text" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("message.filterVideoCall"))
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class: [
                                    "quick-filter-card",
                                    { selected: _vm.localFilterLostChats },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleFilter("lostChats")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "filter-icon-wrapper" },
                                    [_c("md-icon", [_vm._v("phone_missed")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "filter-text" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("message.filterLostChat"))
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class: [
                                    "quick-filter-card",
                                    { selected: _vm.localFilterClosedByAgent },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleFilter("closedByAgent")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "filter-icon-wrapper" },
                                    [_c("md-icon", [_vm._v("support_agent")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "filter-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("message.filterClosedByAgent")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "filter-options" }, [
                            _c("h4", [_vm._v("Site Seçimi")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "custom-select-wrapper" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "custom-select",
                                    class: { open: _vm.isSiteDropdownOpen },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.toggleSiteDropdown.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "selected-value" },
                                      [
                                        _vm._v(
                                          "\n                                                    " +
                                            _vm._s(
                                              _vm.localSelectedSite ||
                                                _vm.$t("message.allSites")
                                            ) +
                                            "\n                                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "dropdown-arrow",
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isSiteDropdownOpen
                                  ? _c(
                                      "div",
                                      { staticClass: "custom-dropdown" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dropdown-item",
                                            class: {
                                              selected: !_vm.localSelectedSite,
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.selectSite(null)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                    " +
                                                _vm._s(
                                                  _vm.$t("message.allSites")
                                                ) +
                                                "\n                                                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.customerDomains,
                                          function (site) {
                                            return _c(
                                              "div",
                                              {
                                                key: site,
                                                staticClass: "dropdown-item",
                                                class: {
                                                  selected:
                                                    _vm.localSelectedSite ===
                                                    site,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.selectSite(site)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(site) +
                                                    "\n                                                "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "filter-options" }, [
                            _c("h4", [_vm._v("Chat Puanı")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "rating-filter" },
                              [
                                _c("a-rate", {
                                  attrs: { "allow-clear": true },
                                  model: {
                                    value: _vm.localPoint,
                                    callback: function ($$v) {
                                      _vm.localPoint = $$v
                                    },
                                    expression: "localPoint",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "bottom",
                                        },
                                        expression:
                                          "{ followCursor: true, placement: 'bottom' }",
                                      },
                                    ],
                                    staticClass: "question-button",
                                    attrs: {
                                      content: _vm.$t(
                                        "message.archiveAllRated"
                                      ),
                                    },
                                    on: { click: _vm.clearRating },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                ?\n                                            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeFilterTab === "platforms",
                              expression: "activeFilterTab === 'platforms'",
                            },
                          ],
                          staticClass: "filter-tab-pane",
                        },
                        [
                          _c("div", { staticClass: "filter-options" }, [
                            _c("h4", [_vm._v("Platform Seçimi")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "platform-grid" },
                              _vm._l(
                                _vm.multiSelectOptions,
                                function (platform) {
                                  return _c(
                                    "div",
                                    {
                                      key: platform.name,
                                      class: [
                                        "platform-card",
                                        {
                                          selected: _vm.isPlatformSelected(
                                            platform.name
                                          ),
                                        },
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.togglePlatform(
                                            platform.name
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "platform-icon" },
                                        [
                                          platform.name === "Whatsapp"
                                            ? _c("WhatsappIcon", {
                                                staticClass:
                                                  "platform-icon-svg",
                                                attrs: { color: "#25D366" },
                                              })
                                            : platform.name === "Instagram"
                                            ? _c("InstagramIcon", {
                                                staticClass:
                                                  "platform-icon-svg",
                                                attrs: {
                                                  "special-background-mode": "",
                                                },
                                              })
                                            : platform.name === "Telegram"
                                            ? _c("TelegramIcon", {
                                                staticClass:
                                                  "platform-icon-svg",
                                              })
                                            : platform.name === "Supsis"
                                            ? _c("SupsisIcon", {
                                                staticClass:
                                                  "platform-icon-svg",
                                              })
                                            : platform.name === "Messenger"
                                            ? _c("MessengerIcon", {
                                                staticClass:
                                                  "platform-icon-svg",
                                              })
                                            : platform.name === "Trendyol"
                                            ? _c("TrendyolIcon", {
                                                staticClass:
                                                  "platform-icon-svg",
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "platform-name" },
                                        [_vm._v(_vm._s(platform.name))]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeFilterTab === "starters",
                              expression: "activeFilterTab === 'starters'",
                            },
                          ],
                          staticClass: "filter-tab-pane",
                        },
                        [
                          _c("div", { staticClass: "filter-options" }, [
                            _c("h4", [_vm._v("Sohbet Başlatan")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "destroyer-grid" },
                              _vm._l(
                                _vm.starterMultiSelectOptions,
                                function (starter) {
                                  return _c(
                                    "div",
                                    {
                                      key: "starter-" + starter.name,
                                      class: [
                                        "destroyer-card",
                                        {
                                          selected: _vm.isStarterSelected(
                                            starter.name
                                          ),
                                        },
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleStarter(starter.name)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "destroyer-icon-wrapper",
                                        },
                                        [
                                          starter.name === "user"
                                            ? _c("md-icon", [_vm._v("people")])
                                            : starter.name === "visitor"
                                            ? _c("md-icon", [_vm._v("person")])
                                            : starter.name === "api"
                                            ? _c("md-icon", [_vm._v("api")])
                                            : starter.name === "broadcast"
                                            ? _c("md-icon", [
                                                _vm._v("campaign"),
                                              ])
                                            : starter.name ===
                                              "instagram-comment"
                                            ? _c("md-icon", [_vm._v("chat")])
                                            : starter.name === "page-comment"
                                            ? _c("md-icon", [
                                                _vm._v("chat_bubble"),
                                              ])
                                            : starter.name ===
                                              "instagram-mention"
                                            ? _c("md-icon", [
                                                _vm._v("alternate_email"),
                                              ])
                                            : starter.name === "trendyol"
                                            ? _c("md-icon", [
                                                _vm._v("storefront"),
                                              ])
                                            : starter.name === "automation"
                                            ? _c("md-icon", [_vm._v("bolt")])
                                            : starter.name ===
                                              "voice-agent-call"
                                            ? _c("md-icon", [_vm._v("call")])
                                            : _c("md-icon", [_vm._v("chat")]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "destroyer-name" },
                                        [
                                          starter.name === "user"
                                            ? [_vm._v("Kullanıcı")]
                                            : starter.name === "visitor"
                                            ? [_vm._v("Ziyaretçi")]
                                            : starter.name === "api"
                                            ? [_vm._v("API")]
                                            : starter.name === "broadcast"
                                            ? [_vm._v("Toplu Mesaj")]
                                            : starter.name ===
                                              "instagram-comment"
                                            ? [_vm._v("Instagram Yorumu")]
                                            : starter.name === "page-comment"
                                            ? [_vm._v("Facebook Yorumu")]
                                            : starter.name ===
                                              "instagram-mention"
                                            ? [_vm._v("Instagram Mention")]
                                            : starter.name === "trendyol"
                                            ? [_vm._v("Trendyol")]
                                            : starter.name === "automation"
                                            ? [_vm._v("Otomasyon")]
                                            : starter.name ===
                                              "voice-agent-call"
                                            ? [_vm._v("Telefon Araması")]
                                            : [_vm._v(_vm._s(starter.name))],
                                        ],
                                        2
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeFilterTab === "destroyers",
                              expression: "activeFilterTab === 'destroyers'",
                            },
                          ],
                          staticClass: "filter-tab-pane",
                        },
                        [
                          _c("div", { staticClass: "filter-options" }, [
                            _c("h4", [_vm._v("Sohbet Kapatan")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "destroyer-grid" },
                              _vm._l(
                                _vm.destroyerMultiSelectOptions,
                                function (destroyer) {
                                  return _c(
                                    "div",
                                    {
                                      key: "destroyer-" + destroyer.name,
                                      class: [
                                        "destroyer-card",
                                        {
                                          selected: _vm.isDestroyerSelected(
                                            destroyer.name
                                          ),
                                        },
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleDestroyer(
                                            destroyer.name
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "destroyer-icon-wrapper",
                                        },
                                        [
                                          destroyer.name === "Agent"
                                            ? _c("md-icon", [_vm._v("people")])
                                            : destroyer.name === "Visitor"
                                            ? _c("md-icon", [_vm._v("person")])
                                            : destroyer.name === "System"
                                            ? _c("md-icon", [
                                                _vm._v("settings_suggest"),
                                              ])
                                            : destroyer.name === "Chatbot"
                                            ? _c("md-icon", [
                                                _vm._v("smart_toy"),
                                              ])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "destroyer-name" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "archive.destroyedBy." +
                                                  destroyer.name.toLowerCase()
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeFilterTab === "tags",
                              expression: "activeFilterTab === 'tags'",
                            },
                          ],
                          staticClass: "filter-tab-pane",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "filter-options" },
                            [
                              _c("h4", [
                                _vm._v(_vm._s(_vm.$t("message.tags"))),
                              ]),
                              _vm._v(" "),
                              _c("multiselect", {
                                attrs: {
                                  multiple: true,
                                  options: _vm.allTags,
                                  placeholder: _vm.$t("message.tags"),
                                  label: "name",
                                  "track-by": "name",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function (props) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "tag-option" },
                                            [
                                              _c("div", {
                                                staticClass: "tag-color",
                                                style: {
                                                  background:
                                                    props.option.color,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "option__title",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.option.name)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2197388699
                                ),
                                model: {
                                  value: _vm.localTagsMultiSelectValue,
                                  callback: function ($$v) {
                                    _vm.localTagsMultiSelectValue = $$v
                                  },
                                  expression: "localTagsMultiSelectValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeFilterTab === "users",
                              expression: "activeFilterTab === 'users'",
                            },
                          ],
                          staticClass: "filter-tab-pane",
                        },
                        [
                          _c("div", { staticClass: "filter-options" }, [
                            _c("h4", [_vm._v("Kullanıcı Seçimi")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-search-wrapper" }, [
                              _c(
                                "div",
                                { staticClass: "user-search-input" },
                                [
                                  _c(
                                    "md-icon",
                                    { staticClass: "search-icon" },
                                    [_vm._v("search")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.userSearchQuery,
                                        expression: "userSearchQuery",
                                      },
                                    ],
                                    staticClass: "search-input",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Kullanıcı ara...",
                                    },
                                    domProps: { value: _vm.userSearchQuery },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.userSearchQuery =
                                          $event.target.value
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "users-list" },
                              _vm._l(_vm.filteredUsers, function (user) {
                                return _c(
                                  "div",
                                  {
                                    key: user.id,
                                    class: [
                                      "user-item",
                                      {
                                        selected:
                                          _vm.localSelectedUser === user.id,
                                      },
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectUser(user.id)
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "user-avatar" }, [
                                      user.id === null
                                        ? _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("group")]
                                          )
                                        : user.id === "only-chatbot"
                                        ? _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("smart_toy")]
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "user-initial" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getUserInitial(user.label)
                                                )
                                              ),
                                            ]
                                          ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "user-info" }, [
                                      _c("div", { staticClass: "user-name" }, [
                                        _vm._v(_vm._s(user.label)),
                                      ]),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }